import { Box, Card, CircularProgress, IconButton, Tooltip } from '@mui/material';
import { BasicResponse, FileData, PanderCountItem} from '../../../../api/models/schema';
import InfoIcon from '@mui/icons-material/Info';
import { UploadFileButton } from '../../../../common/uploadFileButton';
import { useContext } from 'react';
import { ClientContext } from '../../../../context/clientContext';
import { PanderFormContext } from '../../../../context/panderFormContext';

export interface ClientTabProps {
    panderUploadStatus?: PanderCountItem,
    onAdd: (fileData:FileData) => void
}

export default function ClientPanderTab(props: ClientTabProps) {

  const { client } = useContext(ClientContext);
  const panderFormCtxt = useContext(PanderFormContext);


  //uploads pander file
  async function handleUploadPanderFile(
    selectedFile: string,
    fileName: string,
    mimeType: string,
    size: number
  ) {

    const fileData: FileData = {
      name: fileName,
      mimeType: mimeType,
      data: selectedFile.replace('data:text/csv;base64,', ''),
    };

    props.onAdd(fileData);

  }
  
    return (
        <Card
                          style={{
                            // maxWidth: '1400',
                            // margin: 5,
                            padding: 20,
                            border: "1px solid #cecece",
                            borderRadius: 10,
                            backgroundColor: "#f2f2f2",
                            textDecoration: "none",
                          }}
                        >

                        <Box  sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                            }}>
                            <br/><br/>
                            <Tooltip title="Pander file must be a .csv file that contains the following columns( first, last, address line 1, city, state, zip )">
                            <IconButton>
                         <InfoIcon />
                         </IconButton>
                            </Tooltip>
                            </Box>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            Number of Pander Records : 
                            {props.panderUploadStatus
                              ? props.panderUploadStatus.totalNumPanderFiles
                              : client?.numPanderRecords}
                          </Box>


                          
                          {client && (
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "start",
                                  alignItems: "center",
                                  gap: 2,
                                }}
                              >
                                {panderFormCtxt.isLoading && (
                                  <CircularProgress />
                                )}

                                {!panderFormCtxt.isLoading && (
                                  <UploadFileButton
                                    id="uploadPander"
                                    accept=".csv"
                                    onChange={handleUploadPanderFile}
                                  />
                                )}

                                {panderFormCtxt.errorMessage && (
                                  <p className="text-red-500">
                                    {panderFormCtxt.errorMessage}
                                    
                                  </p>
                                )}
                                {props.panderUploadStatus && (
                                  <Box
                                    sx={{
                                      fontSize: 12,
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "start",
                                      width: 800,
                                      color: "gray",
                                      gap: 3,
                                    }}
                                  >
                                    <Box sx={{}}>
                                      <p className="flex w-full m-0">
                                        <span>
                                          Previous Number of Pander Records:{" "}
                                        </span>
                                        {props.panderUploadStatus.previousNumPanderFiles}
                                      </p>
                                      <p className="flex w-full m-0">
                                        <span>
                                          Added Number of Pander Records:{" "}
                                        </span>
                                        {props.panderUploadStatus.newNumPanderFiles}
                                      </p>
                                    </Box>
                                    <Box>
                                      <p className="flex w-full  m-0">
                                        <span>
                                          Duplicate Number of Pander Records:{" "}
                                        </span>
                                        {props.panderUploadStatus.duplicateNumPanderFiles}
                                      </p>
                                      <p className="flex w-full  m-0">
                                        <span>
                                          Total Number of Pander Records:{" "}
                                        </span>
                                        {props.panderUploadStatus.totalNumPanderFiles}
                                      </p>
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          )}

                         
                        </Card>
    )
}